import { createContext, useContext } from "react"

export const ScrollContext = createContext({
  isAlreadyScroll: false,
  scrollToggle: () => {},
})

export const ScrollProvider = ScrollContext.Provider
export const useScrollCtx = () => useContext(ScrollContext)
